function scroll2top() {

  jQuery(function($) {
    $("#gotop").scrollToTop();
  });

};

// Scroll to top function call
jQuery(function($) {
  $.fn.scrollToTop = function() {

    $(this).on('click', function() {
      $("html, body").animate({
        scrollTop: 0
        }, {duration:900, easing:'easeInOutExpo'})
    })
  }
});
